import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { IDynamicPage } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { attachStyles } from '../../utils/attach-styles';

@Component({
  selector: 'epc-dynamic-layout-builder',
  templateUrl: './dynamic-layout-builder.component.html',
  styleUrls: ['./dynamic-layout-builder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicLayoutBuilderComponent implements OnInit {
  @Input()
  public schema: IDynamicPage | null = null;

  constructor(private elementRef: ElementRef) {}

  public ngOnInit() {
    attachStyles(this.elementRef.nativeElement, this.schema?.styles ?? {});
  }
}
